import card, { cardVariants as baseCardVariants, type CardVariantsType } from './card';
import carousel, { cardCarouselVariants, type CardCarouselVariantsType } from './carousel';
import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const cards = {
  card,
  carousel,
};

export const cardsVariants = {
  card: baseCardVariants,
  carousel: cardCarouselVariants,
};

export type CardsComponentsType = 'card' | 'carousel';

type CombinedCardVariantsType = CardVariantsType & CardCarouselVariantsType;

export interface CardsType {
  /** The Card subcomponent types. */
  SubComponents: Record<CardsComponentsType, Product.VariantKeyModes<CombinedCardVariantsType>>;
  /** The Card component types. */
  Card: CustomTheme.VariantKeys<CardVariantsType>;
  /** The Carousel Card component types. */
  Carousel: CustomTheme.VariantKeys<CardCarouselVariantsType>;
}

export default cards;
